// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"52b71666","734":"7f732ea9"}[chunkId] + ".chunk.css";
};